/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const SenderFundingIdColumnFormatter = (cellContent, row, rowIndex) => {
  const { senderFundingId } = row;

  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {senderFundingId ? senderFundingId : `-`}
      </div>
      <> </>
    </>
  );
};
